import Container from '@atoms/Container';
import NearestMore from '../franchise/nearest-more';
import paddingDefault from '@utils/paddingDefault';
import RichTextEditorStyles from '@utils/RichTextEditorStyles';
import { graphql } from 'gatsby';
import React from 'react';

const MetroDetail = ({ data, disableNearby, nearbyData }) => {

    const { copy } = data;

    return (
        <div css={[paddingDefault(), styles.background]}>
            <Container>
                <div css={styles.metroDetailWrap}>
                    <div
                        fullWidth={!disableNearby}
                        css={[RichTextEditorStyles, styles.copyWrap]}
                        dangerouslySetInnerHTML={{ __html: copy }}
                    />
                    {!disableNearby && (
                        <aside disable={disableNearby}>
                            <NearestMore maxItems={5} data={nearbyData} />
                        </aside>
                    )}
                </div>
            </Container>
        </div>
    );
};

const styles = {
    background: {
        position: "relative",
        zIndex: 10,
        backgroundColor: "#F3F4F6"
    },
    metroDetailWrap: {
        display: "flex",
        flexDirection: "column-reverse",
        justifyContent: "space-between",
        alignItems: "flex-start",
        "@media (min-width: 1024px)": {
            flexDirection: "row"
        }
    },
    copyWrap: (fullWidth) => ({
        paddingTop: "0.75rem",
        paddingBottom: "0.75rem",
        "@media (min-width: 1024px)": {
            paddingTop: "3rem",
            paddingBottom: "3rem",
            maxWidth: fullWidth && "500px"
        }
    })
};

export const query = graphql`
  fragment MetroDetailData on CmsPageBuilderBlocks {
    metro_detail {
      copy
    }
  }
`;

export default MetroDetail;
